import { useEffect, useState } from 'react';
import { Client } from '../../2_domain/client/client';
import { isValidDateString } from '../../lib/util/dateFormatter';
import useDatePicker from '../core/components/buttons/useDatePicker';

const useClientFormController = (
  onClientChange: (newClient: Client) => void,
  onClientValid: (isValid: boolean) => void,
  client?: Client
) => {
  const [name, setName] = useState(client?.name ?? '');

  const birth = useDatePicker({
    isNew: client === undefined,
    base: client?.birthday,
  });

  const lastPeriod = useDatePicker({
    isNew: client === undefined,
    base: client?.menstrualDate,
  });

  /// gender
  const [gender, setGender] = useState(client?.gender ?? undefined);

  /// pregnancy
  const [pregnancy, setPregnancy] = useState(client?.pregnancy ?? false);

  /// nationality
  const [nationality, setNationality] = useState(
    client?.nationality ?? undefined
  );

  /// iDNumber
  const [idNumber, setIdNumber] = useState(client?.idNumber ?? '');

  /// passportNumber
  const [passportNumber, setPassportNumber] = useState(
    client?.passportNumber ?? ''
  );

  /// phone
  const [phone, setPhone] = useState(client?.phone ?? '');

  /// email
  const [email, setEmail] = useState(client?.email ?? '');

  /// memo
  const [memo, setMemo] = useState(client?.memo ?? '');

  useEffect(() => {
    const isBirthdayValid = isValidDateString(
      birth.year + '-' + birth.month + '-' + birth.day
    );
    const isPeriodValid = isValidDateString(
      lastPeriod.year + '-' + lastPeriod.month + '-' + lastPeriod.day
    );
    if (
      !birth.isDayValid ||
      !birth.isMonthValid ||
      !birth.isYearValid ||
      !isBirthdayValid ||
      (gender === 'FEMALE' &&
        pregnancy &&
        (!lastPeriod.isDayValid ||
          !lastPeriod.isMonthValid ||
          !lastPeriod.isYearValid ||
          !isPeriodValid)) ||
      gender === undefined ||
      nationality === undefined ||
      (passportNumber === '' && idNumber === '') ||
      // phone === '' ||
      // email === '' ||
      name === ''
    ) {
      onClientValid(false);
      return;
    } else {
      const newClient: Client = {
        id: client === undefined ? -1 : client.id,
        clientSerial: '',
        name: name,
        birthday: new Date(birth.year + '-' + birth.month + '-' + birth.day),
        menstrualDate:
          isPeriodValid && gender === 'FEMALE'
            ? new Date(
                lastPeriod.year + '-' + lastPeriod.month + '-' + lastPeriod.day
              )
            : undefined,
        gender: gender,
        idNumber: idNumber,
        pregnancy: gender === 'FEMALE' ? pregnancy : false,
        passportNumber: passportNumber,
        nationality: nationality,
        phone: phone,
        email: email,
        memo: memo,
        createdAt: new Date(),
      };
      onClientValid(true);
      onClientChange(newClient);
    }
  }, [
    client,
    name,
    birth.day,
    birth.month,
    birth.year,
    birth.isDayValid,
    birth.isMonthValid,
    birth.isYearValid,
    lastPeriod.day,
    lastPeriod.month,
    lastPeriod.year,
    lastPeriod.isDayValid,
    lastPeriod.isMonthValid,
    lastPeriod.isYearValid,
    gender,
    pregnancy,
    nationality,
    idNumber,
    passportNumber,
    phone,
    email,
    memo,
    onClientValid,
    onClientChange,
  ]);

  return {
    name,
    setName,
    birth,
    lastPeriod,
    gender,
    setGender,
    pregnancy,
    setPregnancy,
    nationality,
    setNationality,
    idNumber,
    setIdNumber,
    passportNumber,
    setPassportNumber,
    phone,
    setPhone,
    email,
    setEmail,
    memo,
    setMemo,
  };
};

export default useClientFormController;
